import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import User from '../models/User';
import AirlineType from '../models/AirlineType';

const userManagementReqHandler = {

  getUsers: (): Promise<ApiResponse<User[]>> => {
    return genericApi.get(`admin/user`);
  },
  getAirlines: (ghaId?: number): Promise<ApiResponse<Array<AirlineType>>> => {
    const keyParam: string = ghaId ? `?ghaId=${ghaId}` : '';

    return genericApi.get(`airlines${keyParam}`);
  },
  getAirlinesForUser: (userId?: number): Promise<ApiResponse<Array<AirlineType>>> => {
    const keyParam: string = userId ? `?userId=${userId}` : '';
    return genericApi.get(`user-airlines${keyParam}`);
  },
  addAirline: (airlineId: number, userId: number): Promise<ApiResponse<Array<AirlineType>>> => {
    return genericApi.post(`airline/${airlineId}/${userId}`);
  },
  deleteAirline: (airlineId: number, userId: number): Promise<ApiResponse<Array<AirlineType>>> => {
    return genericApi.delete(`airline/${airlineId}/${userId}`);
  },
  deactivateUser: (id: number, reason: string): Promise<ApiResponse<undefined>> => {
    return genericApi.put(`admin/user/deactivate`, {id, reason});
  },
  changePassword: (password: string, confirmPassword: string, tel: string): Promise<ApiResponse<{detailsStoreToken: string}>> => {
    return genericApi.post(`change_password`, {confirmPassword, password, tel});
  },
  updateUserPassword: (id: number, password: string): Promise<ApiResponse<{detailsStoreToken: string}>> => {
    return genericApi.put(`admin/user/update/password`, {id, password});
  },
  storeUserDetails: (email: string, password: string, firstName: string, lastName: string, role: string): Promise<ApiResponse<{token: string}>> => {
    return genericApi.put(`admin/user/store_details`, {email, password, firstName, lastName, role});
  },
  getStoredUserDetails: (token: string): Promise<ApiResponse<{email: string, password: string, firstName: string, lastName: string, role: number}>> => {
    return genericApi.get(`admin/user/store_details?token=${token}`);
  },
  upsertUser: (id: number, firstName: string, lastName: string, email: string, role: string): Promise<ApiResponse<undefined>> => {
    if(id > 0) {
      return genericApi.post(`admin/user/update`, {id, firstName, lastName, email, role});
    }
    return genericApi.put(`admin/user/register`, {firstName, lastName, email, role});
  }
};

export default userManagementReqHandler;